import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function fetchProviders() {
  const { data } = await axios.get(`${API}/providers`);
  return data.providers;
}

export async function searchTorrents({ query, category, providerIds }) {
  const { data } = await axios.get(`${API}/search`, {
    params: { query, category, providers: providerIds.join(",") },
  });
  return data;
}

export async function browseTorrents({ type, category, providerIds }) {
  const { data } = await axios.get(`${API}/browse`, {
    params: { type, category, providers: providerIds.join(",") },
  });
  return data;
}

export async function fetchDetails({ provider, url, infoHash }) {
  const { data } = await axios.get(`${API}/details`, {
    params: { provider, url, infohash: infoHash },
  });
  return data;
}

export function torrentFileUrl({ infoHash, link, name }) {
  const params = new URLSearchParams({ infohash: infoHash });
  if (link) params.set("link", link);
  if (name) params.set("name", name);
  return `${API}/torrent-file?${params.toString()}`;
}
